import { RESET } from '../redux/game'
import adminApi from '../services/admin-api'

// Actions
const FETCH_RESOURCES_START = 'ascension/resources/fetching'
const FETCH_RESOURCES_SUCCESS = 'ascension/resources/success'
const FETCH_RESOURCES_ERROR = 'ascension/resources/error'

// Reducer
const initialState = {
  isLoading: false,
  isLoaded: false,
  error: null,
  resources: []
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_RESOURCES_START: {
      return {
        ...state,
        isLoading: true,
        error: null
      }
    }
    case FETCH_RESOURCES_SUCCESS: {
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        error: null,
        resources: action.data
      }
    }
    case FETCH_RESOURCES_ERROR: {
      return {
        ...state,
        isLoaded: false,
        isLoading: false,
        error: action.data
      }
    }
    case RESET: {
      return initialState
    }
    default: return state
  }
}

export default reducer

// Action Creators

export function fetchResourcesStart () {
  return {
    type: FETCH_RESOURCES_START
  }
}

export function fetchResourcesSuccess (data) {
  return {
    type: FETCH_RESOURCES_SUCCESS,
    data
  }
}

export function fetchResourcesError (error) {
  return {
    type: FETCH_RESOURCES_ERROR,
    data: error
  }
}

export function fetchResources ({ environment, eventId, participantId }) {
  return async (dispatch) => {
    dispatch(fetchResourcesStart())

    try {
      const response = await adminApi.getResources({ environment, eventId, participantId })
      dispatch(fetchResourcesSuccess(response))
    } catch (e) {
      dispatch(fetchResourcesError(e))
    }
  }
}
